<template>
  <div
    id="header"
    class="header"
  >
    <csm-banner ref="cmsBanner" />
    <top-bar ref="topBar" />
    <main-bar ref="mainBar" />
    <nav-bar ref="navBar" />
    <transition name="fade">
      <scrollable-menu
        v-show="isShowScrollableMenu"
        ref="scrollableMenu"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Components */
import TopBar from './top-bar/top-bar.vue';
import CsmBanner from './csm-banner.vue';
import MainBar from './main-bar.vue';
import NavBar from './nav-bar.vue';
import ScrollableMenu from './scrollable-menu.vue';

export default {
  name: 'app-header',
  components: {
    TopBar,
    MainBar,
    NavBar,
    CsmBanner,
    ScrollableMenu,
  },
  inject: ['adaptive'],
  data() {
    return {
      offsetScrollableMenu: 0,
      isActiveScrollableMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      MAIN_MENU: 'menu/mainMenu',
      LOGGED_IN: 'user/loggedIn',
    }),

    componentsForCalcOffset: () => ['cmsBanner', 'topBar', 'mainBar', 'navBar'],

    isShowScrollableMenu() {
      return this.isActiveScrollableMenu
        && this.adaptive.isDesktop
        && this.$isFeatureEnabled(this.featuresEnum.SCROLLABLE_HEADER_DESKTOP);
    },
  },

  mounted() {
    if (this.LOGGED_IN) {
      this.LOAD_COUPONS();
      this.LOAD_ORDERS_NOTIFICATIONS();
      this.LOAD_PROMOTIONS_NOTIFICATIONS();
      this.LOAD_PROMOTIONS_NOTIFICATIONS_COUNT();
      this.LOAD_FAVORITES_SHORT();
    } else {
      this.$auth.emmiter.on('login', () => {
        this.LOAD_COUPONS();
        this.LOAD_ORDERS_NOTIFICATIONS();
        this.LOAD_PROMOTIONS_NOTIFICATIONS();
        this.LOAD_PROMOTIONS_NOTIFICATIONS_COUNT();
      });
    }
    this.LOAD_HEADER_CART();
    // Если не загрузили меню на сервере, подгружаем на клиенте
    if (!this.MAIN_MENU?.length) {
      this.LOAD_MENU();
    }

    this.componentsForCalcOffset.forEach((item) => {
      const itemHeight = this.$refs[item].$el.getBoundingClientRect
        ? this.$refs[item].$el.getBoundingClientRect().height
        : 0;

      this.offsetScrollableMenu += itemHeight;
    });
  },

  created() {
    if ((typeof window === 'undefined')) return;

    if (this.$isFeatureEnabled(this.featuresEnum.SCROLLABLE_HEADER_DESKTOP)) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    ...mapActions({
      LOAD_MENU: 'menu/loadMainMenu',
      LOAD_COUPONS: 'user/loadCoupons',
      LOAD_FAVORITES_SHORT: 'favorites/loadFavoritesShort',
      LOAD_HEADER_CART: 'cart/loadHeaderCart',
      LOAD_ORDERS_NOTIFICATIONS: 'orders/fetchOrdersForNotifications',
      LOAD_PROMOTIONS_NOTIFICATIONS: 'promotions/fetchMessages',
      LOAD_PROMOTIONS_NOTIFICATIONS_COUNT: 'promotions/fetchUnreadMessagesCount',
    }),
    handleScroll() {
      const headerTop = this.$el.getBoundingClientRect().top;

      this.isActiveScrollableMenu = Math.abs(headerTop) > this.offsetScrollableMenu;
    },
  },

  serverPrefetch() {
    return Promise.all([
      this.LOAD_MENU(),
    ]);
  },
};
</script>

<style lang="scss">
.header {
  border-bottom: 1px solid $gray_lu;
  box-shadow: 0 4px 32px rgba(0, 0, 0, .08);
}
</style>
